// extracted by mini-css-extract-plugin
export default {"title-section":"_2dFcMHIi9N","titleSection":"_2dFcMHIi9N","not-available":"_2izJvc_KSi","notAvailable":"_2izJvc_KSi"};
    if(module.hot) {
      // 1623933175269
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  